import { useDropzone } from 'react-dropzone'
import React, { useState } from 'react'
import { useToast } from '~/lib/ui/toast'
import { apiPost } from '~/util/api'
import { cn } from '~/lib/utils'
import Spinner from '../shared/Spinner'
import { useCandidate } from './CandidateProvider'

const UploadCandidateResume = ({ className, helpText, ...props }) => {
  const { candidateId } = useCandidate()
  const { setUploadedResumeId } = props
  const [resumeIsUploading, setResumeIsUploading] = useState(false)
  const [fileName, setFileName] = useState('')
  const [resumeFieldsArePopulated, setResumeFieldsArePopulated] =
    useState(false)
  const [isDraggingOver, setIsDraggingOver] = useState(false)
  const { toast } = useToast()
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      '*/*/pdf': ['.pdf'],
      '*/*/msword': ['.doc'],
      '*/*/document': ['.docx'],
    },
    onDropAccepted: (incomingFiles) => saveNewResume(incomingFiles[0]),
    onDropRejected: (incomingFiles) => rejectionMessage(incomingFiles),
    onDragEnter: () => setIsDraggingOver(true),
    onDragLeave: () => setIsDraggingOver(false),
    onDrop: () => setIsDraggingOver(false),
    maxSize: 15_000_000, // 15MB
    disabled: resumeIsUploading,
  })

  const rejectionMessage = (incomingFiles) => {
    const {
      file: { type },
      errors,
    } = incomingFiles[0]
    const description = errors.map((e) => ` • ${e.message}`).join('\n')
    console.error('File upload rejected:', description)
    if (type) {
      toast({
        description,
        title: 'Could Not Upload Resume',
        variant: 'destructive',
        duration: 10_000,
      })
    }
  }

  const saveNewResume = async (file) => {
    setResumeIsUploading(true)
    const name = file.name.split('.')[0]
    const formData = new FormData()
    formData.append('imported_resume', file)
    formData.append('candidate_id', candidateId)

    try {
      const response = await apiPost(
        '/coach/service_requests/upload_candidate_resume',
        formData,
        true,
      )
      setResumeIsUploading(false)
      setUploadedResumeId(response.data.document_id)
      setFileName(name)
      setResumeFieldsArePopulated(true)
    } catch (e) {
      setResumeIsUploading(false)
      console.error('Error saving new resume', e)
      toast({
        description: 'Error: Resume upload failed.',
        variant: 'destructive',
      })
      return
    }
  }

  const baseRootClassName = cn(
    'min-h-[10rem] p-4 border-dashed border text-center content-center justify-items-center',
    className,
  )
  const defaultRootClassName = isDraggingOver
    ? baseRootClassName + ' border-primary border-2 bg-lily-blue'
    : baseRootClassName
  const rootClassName = resumeIsUploading
    ? defaultRootClassName
    : defaultRootClassName + ' cursor-pointer'

  return (
    <div className="px-4 pb-4">
      <div
        {...getRootProps({
          className: rootClassName,
        })}
      >
        <input {...getInputProps()} />
        {resumeIsUploading && <Spinner show={true} className="w-14" />}
        {!resumeIsUploading && {
          ...(resumeFieldsArePopulated ? (
            <div>
              <p>Resume uploaded successfully</p>
              <p>{fileName}</p>
            </div>
          ) : (
            <div>
              <p>
                {helpText ||
                  `Drag and drop candidate's resume here, or click to select`}
              </p>
              <em>(Files must be in .pdf, .doc, or .docx format)</em>
            </div>
          )),
        }}
      </div>
    </div>
  )
}
export default UploadCandidateResume
